export const emailRegex = /^[a-zA-Z0-9][a-zA-Z0-9_.-]*(\.[a-zA-Z][a-zA-Z0-9_.-]*)?@[a-z][a-zA-Z-0-9-]*\.[a-z]+(\.[a-z]+)?$/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
export const nameRegex = /^[a-zA-ZÀ-ÿ\- ']+( [a-zA-ZÀ-ÿ\- ']+)*$/;
export const maxFourDigitRegex = /^\d{0,4}$/;
export const fourDigitRegex = /^\d{4}$/;
export const fourCharactersRegex = /^.{4,}$/;
export const fontSizeRegex = /font-size: \d+px;\s{0,1}/;
export const governmentalIdRegex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
export const kwiffBetkwiffDomainRegex = /(\.|\/)(bet)?kwiff\.(com|org|ke)(:\d+)?$/;
export const maxTwoDecimalsFloatRegex = /^([1-9][0-9]*(\.|,)?[0-9]{0,2}|0(\.|,)[0-9]{0,2}|0)$/;
